import React from "react";
import { AlertTriangle, Edit, X } from "lucide-react";

export function TamFinansCheckModal({ check, onCancel, onConfirm, onEdit }) {
  return (
    <div className="fixed inset-0 z-50 bg-black/40 grid place-items-center p-4" onClick={onCancel} data-testid="tam-finans-check-modal">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-lg max-h-[85vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-4 py-3 border-b border-slate-200">
          <h3 className="font-bold text-slate-900 flex items-center gap-2 text-sm">
            <AlertTriangle size={16} className="text-amber-600" /> Eksik Bilgi · {check.missing.length}/{check.count} kayıt
          </h3>
          <button onClick={onCancel} data-testid="tam-finans-check-close" className="w-7 h-7 grid place-items-center hover:bg-slate-100 rounded"><X size={14} /></button>
        </div>
        <div className="px-4 py-3 text-xs text-slate-600">Aşağıdaki kayıtlarda Tam Finans formu için gerekli bilgiler eksik. Tahsilat kaydını düzenleyip tamamlayabilir veya formu yine de indirebilirsiniz.</div>
        <ul className="px-4 pb-3 space-y-1.5 overflow-y-auto" data-testid="tam-finans-check-list">
          {check.missing.map((m) => (
            <li key={m.id} data-testid={`tam-finans-missing-${m.id}`}>
              <button type="button" onClick={() => onEdit(m.row)} data-testid={`tam-finans-missing-edit-${m.id}`} title="Kaydı açıp tamamla"
                className="w-full text-left border border-amber-200 bg-amber-50/60 hover:bg-amber-100 hover:border-amber-300 rounded-md px-3 py-1.5 text-xs transition-colors">
                <div className="flex items-center gap-2">
                  <span className="font-semibold text-slate-800">{m.icra_foy || "—"}{m.dosya_no ? ` · ${m.dosya_no}` : ""}</span>
                  <span className="text-slate-500 truncate">{m.musteri}</span>
                  <span className="ml-auto inline-flex items-center gap-1 text-indigo-700 font-semibold whitespace-nowrap"><Edit size={11} /> Düzelt</span>
                </div>
                <div className="text-amber-800">Eksik: {m.fields.join(", ")}</div>
              </button>
            </li>
          ))}
        </ul>
        <div className="flex justify-end gap-2 px-4 py-3 border-t border-slate-200">
          <button onClick={onCancel} data-testid="tam-finans-check-cancel" className="px-3 py-1.5 text-xs font-semibold rounded-md border border-slate-300 hover:bg-slate-50">Vazgeç</button>
          <button onClick={onConfirm} data-testid="tam-finans-check-confirm" className="px-3 py-1.5 text-xs font-semibold rounded-md bg-emerald-700 hover:bg-emerald-800 text-white">Yine de indir</button>
        </div>
      </div>
    </div>
  );
}
